import { Bit, BitmaskMappaturaAllarmi, MappaturaAllarmiType } from "@/api";
import {
  Box,
  Button,
  Grid,
  Icon,
  IconButton,
  InputLabel,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

function ModelloDispositivoMappaturaBitmaskDialog({
  bitmask,
  onChange,
}: {
  bitmask: BitmaskMappaturaAllarmi | null | undefined;
  onChange: (
    event: React.SyntheticEvent | null,
    bitmask: BitmaskMappaturaAllarmi | null | undefined
  ) => void;
}) {
  const { t } = useTranslation();
  const [elements, setElements] = useState<Bit[]>(
    bitmask?.bits || [{ index: null, message: null } as Bit]
  );

  const addElement = () => {
    setElements([...elements, { index: null, message: null } as Bit]);
  };

  const removeElement = (index: number) => {
    const newElements = elements.filter((_, i) => i !== index);
    setElements(newElements);
    onChangeElements(null, newElements);
  };

  const onChangeElements = (event:  React.SyntheticEvent | null, newElements: Bit[]) => {
    onChange(event, { type: MappaturaAllarmiType.Bitmask, bits: newElements });
  };

  return (
    <div>
      {elements.map((element, index) => (
        // Horizontal 2 elements gravity left space 8px
        <Box
          key={index}
          display="flex"
          flexDirection="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <Box display="flex" flexDirection="column" mr={1}>
            <InputLabel>{t("mappaturaBitmaskDialog.campi.indice")}</InputLabel>
            <TextField
              value={element.index}
              onChange={(event) => {
                const newElements = [...elements];
                const number = parseInt(event.target.value);

                if (!isNaN(number)) {
                  newElements[index].index = number;
                  setElements(newElements);
                  onChangeElements(null, newElements);
                } else {
                  newElements[index].index = null;
                  setElements(newElements);
                  onChangeElements(null, newElements);
                }
              }}
            />
          </Box>

          <Box display="flex" flexDirection="column" mr={1}>
            <InputLabel>{t("mappaturaBitmaskDialog.campi.messaggio")}</InputLabel>
            <TextField
              value={element.message}
              onChange={(event) => {
                const newElements = [...elements];
                newElements[index].message = event.target.value;
                setElements(newElements);
                onChangeElements(null, newElements);
              }}
            />
          </Box>

          <Grid item mt={3}>
            <IconButton
              onClick={() => {
                removeElement(index);
              }}
              aria-label={t("azioni.elimina")}
              style={{ color: "red" }}
            >
              <Icon>delete_outlined</Icon>
            </IconButton>
          </Grid>
        </Box>
      ))}
      <Button onClick={addElement}>
        {t("mappaturaBitmaskDialog.azioni.aggiungi")}
      </Button>
    </div>
  );
}

export default ModelloDispositivoMappaturaBitmaskDialog;
